<template>
  <v-app>
    <v-menu top v-model="widgetMenu" :close-on-click="false" content-class="custom-shape" :close-on-content-click="false">
       <template v-slot:activator="{attrs }">
         <div v-bind="attrs" style="position: absolute; right: 20px; bottom: 20px; width: 1px; height: 1px"></div>
        </template>
        <div style="width: 510px;" :style="{'height': widgetHeight}">
          <booking-widget 
            :showType="'menu'" 
            :company="company"
            :language="lang"  
            :primaryColor="primaryColor" 
            :secondaryColor="secondaryColor"  
            :seperateTreatments="seperateTreatments" 
            :preSelectedBranch="selectedBranch" 
            :showPrices="showPrices"
            :source="source"
            :leadFormId="leadFormId"
            :startUrl="startUrl"
            :clientIdBooking="clientIdBooking"
            :executedFrom="executedFrom"
            :userAgent="userAgent"  
            :widgetHeight="widgetHeight" 
            :widgetContentHeight="widgetContentHeight"
            :actionType="actionType"
            :bookingId="bookingId"
            :preSelectedTreatment="preSelectedTreatment"
            :multiTreatmentBooking="multiTreatmentBooking"  
            @showWidgetDialog="widgetMenu = $event"
            >
          </booking-widget>
        </div>
    </v-menu>
    <v-dialog v-model="widgetDialog" scrollable max-width="600" content-class="custom-shape" persistent :hide-overlay="fullscreen" :fullscreen="fullscreen">
      <booking-widget 
        :showType="'dialog'" 
        :company="company" 
        :language="lang" 
        :primaryColor="primaryColor" 
        :secondaryColor="secondaryColor" 
        :seperateTreatments="seperateTreatments" 
        :preSelectedBranch="selectedBranch" 
        :showPrices="showPrices"
        :source="source"
        :leadFormId="leadFormId"
        :startUrl="startUrl"
        :clientIdBooking="clientIdBooking"
        :executedFrom="executedFrom"
        :userAgent="userAgent"
        :widgetHeight="widgetHeight" 
        :actionType="actionType"
        :bookingId="bookingId"
        :preSelectedTreatment="preSelectedTreatment"
        :multiTreatmentBooking="multiTreatmentBooking"
        :widgetContentHeight="widgetContentHeight" 
        @showWidgetDialog="widgetDialog = $event"
        >
      </booking-widget>
    </v-dialog>
  </v-app>
</template>

<script>
  import _ from "lodash";
  import db from "./firebase/init";
  import bookingWidget from "./components/bookingWidget";
  import moment from "moment";
  import { bus } from "./main";

  export default {
    name: "Home",
    components: {
      'booking-widget': bookingWidget,
    },

    data: function() {
      return {
        primaryColor: "#00adef",
        secondaryColor: "#f48c00",
        company: "",
        selectedBranch: "",
        widgetDialog: false,
        widgetMenu: false,
        fullscreen: false,
        windowWidth: 0,
        showPrices: false,
        executedFrom: null,
        startUrl: null,
        clientIdBooking: null,
        source: null,
        widgetHeight: "550px",
        windowHeight: 0,
        widgetContentHeight: 446,
        seperateTreatments: false,
        userAgent: null,
        multiTreatmentBooking:false,
        lang: 'NL',
        actionType: 'booking', // possible item: booking, shortcut, cancelBooking
        preSelectedTreatment: null,
        bookingId: null,
        leadFormId: null
      };
    },

    created() {
      this.getWindowSize();
      this.$nextTick(function() {
        window.addEventListener("resize", this.getWindowSize);
      })
      window.addEventListener("resize", this.getWindowSize);
      //console.log("this.$route.query: ", this.$route.query)
      if(this.$route.query.comp){
        this.company = this.$route.query.comp;
        if(this.$route.query.branch){
          this.selectedBranch = this.$route.query.branch;
        }
        if(this.$route.query.lang){
          this.lang = this.$route.query.lang;
        }

        let widgetType = 'dialog';
        if(this.$route.query.type == 'menu'){
          widgetType = 'menu';
        }
        if (
          navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/webOS/i) ||
          navigator.userAgent.match(/iPhone/i) ||
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/iPod/i) ||
          navigator.userAgent.match(/BlackBerry/i) ||
          navigator.userAgent.match(/Windows Phone/i)
        ) {
          this.userAgent = "mobile";
        } 
        else {
          this.userAgent = "desktop";
        }
        if(this.$route.query.shp && this.$route.query.shp == 1){
          this.showPrices = true;
        }

        if(this.$route.query.surl){
          this.startUrl = this.$route.query.surl;
        }
        if(this.$route.query.exsrc){
          this.executedFrom = this.$route.query.exsrc;
        }

        if(this.$route.query.act){
          let actionTypes = ['booking', 'shortcut', 'cancelBooking','leadForm'];
          this.actionType = actionTypes[this.$route.query.act] ? actionTypes[this.$route.query.act] : 'booking';
        }

        if(this.$route.query.bid){
          this.bookingId = this.$route.query.bid;
        }

        if(this.$route.query.lid){
          this.leadFormId = this.$route.query.lid;
        }

        if(this.$route.query.cid){
          this.clientIdBooking = this.$route.query.cid;
        }

        if(this.$route.query.trm){
          this.preSelectedTreatment  = this.$route.query.trm;
        } 

        if(this.$route.query.mtb && this.$route.query.mtb == 1){
          this.multiTreatmentBooking = true;
        }  
        
        if(this.$route.query.spt && this.$route.query.spt == 1){
          this.seperateTreatments = true;
        }  
        if (this.$route.query.src) {
          this.source = this.$route.query.src;
        }

        this.openWidget(widgetType)
      }
      else{
        console.info("Geen bedrijf ingesteld")
      }     
    },

    methods: {
      getWindowSize() {
        this.windowWidth = document.documentElement.clientWidth;
        this.windowHeight = document.documentElement.clientHeight;
      },
      openWidget(type){
        // bus.$emit('startWidget', this.selectedBranch);
        if(type == 'menu'){
          if(this.windowWidth > 680){
            this.widgetMenu = true
          }
          else{
            this.widgetDialog = true
          }
        }
        else{
          this.widgetDialog = true
        }
      },
    },


    watch: {
      windowWidth() {
        if (this.windowWidth <= 680) {
          this.fullscreen = true;
          this.widgetHeight = "100%";
          this.widgetContentHeight = (this.windowHeight - 52);
          
        } 
        else {
          this.fullscreen = false;
          if(this.windowHeight > 700){
            this.widgetHeight = "650px";
            this.widgetContentHeight = 600;
          }
          else{
            this.widgetHeight = (this.windowHeight - 50) +'px';
            this.widgetContentHeight = this.windowHeight - 100;
          }
        }
      }
    },

    computed: {
      version() {
        return this.$store.state.version;
      },
      Companies() {
        return this.$store.state.userCompanies;
      },
      userCompany() {
        return this.$store.state.userCompany;
      },
      userName() {
        return this.$store.state.userName;
      },
      userFirstName() {
        return this.$store.state.userFirstName;
      },
      userLastName() {
        return this.$store.state.userLastName;
      },
      userRole() {
        return this.$store.state.userRole;
      },
      theme() {
        return this.$vuetify.theme.dark ? "dark" : "light";
      },
    }
  };
</script>

<style>
  .custom-shape{
    border-radius: 25px!important;
  }

  .custom-shape::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .custom-shape {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  @media only screen and (max-width: 680px) {
    .custom-shape{
      border-radius: 0px!important;
    }
  } 

  
</style>
<style scoped>
.v-application {
  background: none;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>


